/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
import NamespacedStorage from './NamespacedStorage'

if (typeof global.webCommonStorageInstance === 'undefined') {
  global.webCommonStorageInstance = null
}

// Default namespace should be 'undefined'
// Because that's how react-native-storage looks for global values.
export const initStorage = ({ storageBackend, namespace = undefined }) => {
  const storageConfig = {
    enableCache: true,
    storageBackend,
  }

  const storage = new NamespacedStorage({
    ...storageConfig,
    namespace,
  })

  global.webCommonStorageInstance = storage
}

export const getStorage = () => global.webCommonStorageInstance
export const destroyStorage = () => {
  global.webCommonStorageInstance = null
}
